class TipSubmitter
  constructor: ({@placeId, @csrf}) ->
    @rootUrl = '/merchant-page'

  submitTip: (inputText, isMerchantSpecialTip, triggeredOnPageLoad = false, {success, fail}) ->

    text = inputText.trim()

    obj =
      _csrf: @csrf
      placeId: @placeId
      text: text
      triggeredOnPageLoad: triggeredOnPageLoad
      isMerchantSpecialTip: isMerchantSpecialTip

    $.ajax
      url: "#{@rootUrl}/tips/create"
      method: 'POST'
      data: JSON.stringify obj
      contentType: 'application/json'

      success: (res) ->
        # Server always returns http success, but embeds actual errors in response
        if res.result is 'ok'
          success(res)
          return

        fail(res)
        return

Groupon.TipSubmitter = TipSubmitter
